
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mvo",
      function () {
        return require("private-next-pages/mvo.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mvo"])
      });
    }
  